import { render, staticRenderFns } from "./BrandSelect.vue?vue&type=template&id=bfcab98c&scoped=true&"
import script from "./BrandSelect.vue?vue&type=script&lang=js&"
export * from "./BrandSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcab98c",
  null
  
)

export default component.exports